import { styled } from '@mui/material';
import BasicSelectComponent from 'further-ui/components/BasicSelect';

const BasicSelect = styled(BasicSelectComponent)(({ theme }) => ({
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,

    '& input': {
      color: theme.palette.grey[900],
      fillColor: 'inherit',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: theme.shape.borderRadius,
      borderColor: theme.palette.grey[100],
    },
  },
}));

export default BasicSelect;
